import { AlignmentType, Paragraph, TextRun, WidthType, BorderStyle, Table, TableCell, TableRow } from "docx";


export function summaryText(certInCustomerName, certInApplicationName) {
    return new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 200, after: 300 },
        children: [
            new TextRun({
                text: `${certInCustomerName} engaged ISECURION for performing Web Application Security Audit of their ${certInApplicationName} Web Application.`,
                size: 24,
                color: "000000",
                font: "Arial",
                bold: false,
                italics: false
            })
        ],
    })
}

export const summaryText1 = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 700, after: 300 },
    children: [
        new TextRun({
            text: "NOTE:",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export function sumaryText2(certInAppEnvironment, certInTestingype) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 500 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `Testing was performed on the ${certInAppEnvironment} Environment. ${certInTestingype} ${certInTestingype === "Black box testing methodology (Unauthenticated Testing)"
                        ? "was performed."
                        : "was performed with below-mentioned user role:"
                    }`,
                size: 24,
                font: "Arial",
                color: '000000',
                italics: false,
                bold: false
            }),
        ],
    })
}


export function summaryUserRoles(certInRoles) {
    const names = Array.isArray(certInRoles) ? certInRoles : [];

    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 1, after: 1 },
                        alignment: AlignmentType.CENTER,
                        children: [new TextRun({
                            text: "",
                            font: "Arial",
                            size: 26,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
                new TableCell({
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 10, after: 10 },
                        alignment: AlignmentType.LEFT,
                        children: [new TextRun({
                            text: "",
                            font: "Arial",
                            size: 24,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
            ]
        })
    ];

    names.forEach((name) => {
        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [new TextRun({
                                text: "\u2022",
                                font: "Arial",
                                size: 26,
                                color: '0f0f3f',
                                italics: false
                            })]
                        })],
                    }),
                    new TableCell({
                        width: { size: 30, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [new TextRun({
                                text: name,
                                font: "Arial",
                                size: 24,
                                color: '000000',
                                italics: false,
                                bold: false
                            })]
                        })],
                    }),
                ]
            })
        );
    });


    return new Table({
        width: { size: 35, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.LEFT,
        indent: { size: 600, type: WidthType.DXA },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: rows
    });
}

export const SummaryRecommendation = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 850, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "It is recommended to:",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const recommendationBulletOne = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Ensure that all vulnerabilities are fixed.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const recommendationBulletTwo = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "As part of an effective organizational risk management strategy, vulnerability assessments & penetration test should be conducted on regular basis.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})